export function formatCurrency(value, options = {}) {
    return value.toLocaleString('es-UY', {
        style: 'currency',
        currency: 'UYU',
        maximumFractionDigits: 0,
        ...options
    });
}

export function formatDateInput(value) {

    if (value === '') return '';

    const onlyNumbersAndSlash = value.replace(/[^\d\/]/, '');

    let [day, month, year] = onlyNumbersAndSlash.split('/');

    if (year != null) {
        return `${day}/${month}/${year.substring(0, 4)}`;
    }

    if (month != null) {
        if (month.length < 2) return `${day}/${month.substring(0, 2)}`;
        if (month.length === 2) return `${day}/${month}`;
        return `${day}/${month.substring(0, 2)}/${month.substring(2)}`;
    }

    if (day.length > 2) return `${day.substring(0, 2)}/${day.substring(2)}`;

    return day;
}

export function formatDateInputReverse(value) {

    if (value === '') return '';

    let [year, month, day] = value.split('-');

    return `${day}/${month}/${year.substring(0, 4)}`;
}

